const checkboxBase:React.CSSProperties = {
  marginLeft: -8,
  fontWeight: 500,
  lineHeight: 16,
  fontSize: 10,
};

/** Single width for login / signup / reset / verify inputs and primary actions */
export const LOGIN_AUTH_FIELD_WIDTH_PX = 300;

const loginAuthFieldSizing: React.CSSProperties = {
  width: "100%",
  maxWidth: LOGIN_AUTH_FIELD_WIDTH_PX,
  boxSizing: "border-box",
};

/** Narrow column so inputs and buttons share the same width inside centered login grids */
export const loginAuthColumnSx = {
  width: LOGIN_AUTH_FIELD_WIDTH_PX,
  maxWidth: "100%",
  boxSizing: "border-box",
  alignSelf: "center",
} as const;

export const loginStyles: Record<string, React.CSSProperties> = {
  titleMessage: {
    fontSize: 30,
    fontWeight: 300,
    marginTop: 16,
    marginBottom: 25,
  },
  loginInput: {
    ...loginAuthFieldSizing,
  },
  instructionsMessage: {
    fontSize: 15,
    margin: "25px 10px 25px",
  },
  checkbox: {
    ...checkboxBase,
    marginTop: 5,
    marginBottom: 20,
  },
  showPassword: {
    ...checkboxBase,
    marginTop: -4,
    marginBottom: 0,
  },
  forgotPassword: {
    fontSize: "13px",
    paddingBottom: "12px",
  },
  logoLogin: {
    marginTop: "16px",
    marginBottom: "24px",
    width: "calc(237px * 0.80)",
    height: "calc(58px * 0.80)",
    background: "url(https://hc-images2.s3.amazonaws.com/haven_logo_light.png) no-repeat",
    backgroundSize: "contain",
  },
  logoLoginDark: {
    marginTop: "16px",
    marginBottom: "24px",
    width: "calc(237px * 0.80)",
    height: "calc(58px * 0.80)",
    background: "url(https://hc-images2.s3.amazonaws.com/HC-logo-darkgray.png) no-repeat",
    backgroundSize: "contain",
  },
  textContainer: {
    maxWidth: 350,
    margin: "0px auto 0px",
    width: "auto",
  },
  bottomLink: {
    marginTop: 25,
    textAlign: "center" as const,
    fontSize: 13,
    paddingBottom: 16,
  },
  btn: {
    marginTop: 26,
    ...loginAuthFieldSizing,
  },
  card: {
    maxWidth: "350px",
    marginTop: 16,
  },
  passwordRequirements: {
    fontSize: 14,
    marginTop: 16,
  },
  loginModal: {
    maxHeight: "calc(100vh - 200px)",
    maxWidth: "500px",
  },
  loginModalMobile: {
    overflowY: "auto",
    maxHeight: "100vh",
    height: "100vh",
    maxWidth: "100vw",
    width: "100vw",
  },
  signUpLabel: {
    paddingBottom: "12px",
    marginTop: 26,
  },
};
